import { render, staticRenderFns } from "./matchX.vue?vue&type=template&id=d2dce74e&lang=pug&"
import script from "./matchX.vue?vue&type=script&lang=js&"
export * from "./matchX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports